function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.586 29l-7.24-3.683L3.106 29V10.582h14.48V29z",
  fill: "#C92128"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.964 18.839c-4.953 0-8.89-4.065-8.89-8.892 0-4.953 4.064-8.89 8.89-8.89 4.827 0 8.892 4.064 8.892 8.89.127 4.954-3.938 8.892-8.892 8.892z",
  fill: "#B1B9CC"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.118 16.75A7.494 7.494 0 106.794 3.162a7.494 7.494 0 006.324 13.588z",
  fill: "#9EA8BA"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.43,
  fill: "#B1B9CC"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.43,
  d: "M14.41 3.723L5.138 15.536c.254.127.381.381.635.508l9.272-11.812c-.254-.127-.508-.255-.635-.509zM15.934 5.248L6.916 16.679c.127 0 .254.127.381.127l8.891-11.304c-.127 0-.127-.127-.254-.254zM12.632 2.834L3.74 14.012c.127.127.127.254.255.38l9.018-11.43c-.127 0-.254-.128-.381-.128zM10.6 2.453l-7.748 9.78c.127.255.127.509.254.636l8.256-10.416H10.6z"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.106 9.947c0-4.064 3.175-7.367 7.24-7.494C6.026 2.326 2.47 5.756 2.47 9.947c0 4.319 3.557 7.621 7.875 7.494-4.064-.127-7.24-3.556-7.24-7.494z",
  fill: "#8B99AD"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.23 19.588A9.653 9.653 0 109.695.289a9.653 9.653 0 00-9.382 9.917c.148 5.33 4.588 9.53 9.917 9.382z",
  fill: "#B1B9CC"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.964 16.806a6.859 6.859 0 100-13.718 6.859 6.859 0 000 13.718z",
  fill: "#CBD1DD"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.964 16.425a6.478 6.478 0 100-12.956 6.478 6.478 0 000 12.956z",
  fill: "#8B99AD"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M9.964 15.917a5.97 5.97 0 100-11.94 5.97 5.97 0 000 11.94z",
  fill: "#9EA8BA"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.378 15.282L5.265 6.264c-.254.38-.508.635-.635 1.016l6.605 8.383 1.143-.381zM9.075 15.79L4.122 9.566v.889l4.064 5.081c.254.127.508.127.89.254zM14.537 13.758l-7.24-9.145c-.127.127-.381.127-.508.254l7.367 9.272.38-.381zM15.68 11.345L9.837 3.976c-.38 0-.635 0-1.016.127l6.478 8.257c.254-.381.381-.636.381-1.017z",
  fill: "#B1B9CC"
});
function SvgPlatinum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}
export default SvgPlatinum;